import React from "react";

import PageHeading from "2g-page-heading";

import ProvozniInformacePosledniWidget from "b2b/components/provozni-informace-posledni-widget/ProvozniInformacePosledniWidget";

export function ProvozniInformacePosledniWidgetExample() {
  return (
    <>
      <PageHeading>ProvozniInformacePosledniWidget</PageHeading>
      <div data-testid="ProvozniInformacePosledniWidget">
        <ProvozniInformacePosledniWidget />
      </div>
    </>
  );
}

ProvozniInformacePosledniWidgetExample.propTypes = {};

export default React.memo(ProvozniInformacePosledniWidgetExample);
